import React, { ReactNode } from 'react';
import { ControlsTheme, getThemeStyles } from './controls-theme';

interface ControlButtonProps {
  onClick: () => void;
  children: ReactNode;
  color?: string;
  theme?: ControlsTheme;
}

export const ControlButton: React.FC<ControlButtonProps> = ({
  onClick,
  children,
  color = '#FFFFFF',
  theme = 'minimal',
}) => {
  const { wrapperClass } = getThemeStyles(theme, color);
  return (
    <button onClick={onClick} className={wrapperClass} style={{ color }}>
      {children}
    </button>
  );
};
